import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HeaderPage = () => {
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const notificationsRef = useRef(null);
  const { user } = useAuth(); // Obtener datos del usuario logueado

  // Mapear rutas a títulos
  const getPageTitle = () => {
    const pathToTitle = {
      "/dashboard": "Inicio",
      "/estudiantes": "Estudiantes",
      "/profesores": "Profesores",
      "/notas": "Notas",
      "/boletin": "Boletin",
      "/boletin-final": "5º Período - Boletines Finales",
      "/eventos": "Eventos",
      "/indicadores": "Indicadores",
      "/finanzas": "Finanzas",
      "/horarios": "Horario",
      "/detalles": "Perfil",
    };
    return pathToTitle[location.pathname] || "Página Desconocida";
  };

  const handleProfileClick = () => {
    navigate("/detalles"); // Ruta a la que deseas redirigir
  };

  const handleClickOutside = (event) => {
    if (
      notificationsRef.current &&
      !notificationsRef.current.contains(event.target)
    ) {
      setNotificationsOpen(false);
    }
  };

  useEffect(() => {
    if (notificationsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationsOpen]);

  return (
    <div className=" flex">
      {/* Sidebar */}
      <main className="flex-1 p-4">
        {/* Header */}
        <div className="mb-2 flex justify-between items-center">
          <h1 className="text-title-table text-2xl ml-2 mr-[35px] sm:ml-[0] sm:mr-[0] sm:text-4xl font-bold text-left">
            {getPageTitle()}
          </h1>
          <div className="flex items-center space-x-4 ml-auto relative bg-white px-4 py-2 shadow-md rounded-2xl">
            <div className="text-sm" onClick={handleProfileClick}>
              
              <h1 className="text-blue-900 font-bold">
                {user?.first_name || "Usuario"}
              </h1>
              <p className="text-gray-600 text-sm">
                {user?.rol_id === 1
                  ? "Rector"
                  : user?.rol_id === 2
                  ? "Profesor"
                  : "Estudiante" || "Rol desconocido"}
              </p>
            </div>
            <div
              className="w-12 h-12 rounded-full cursor-pointer flex items-center justify-center bg-blue-900 text-white text-xl font-bold"
              onClick={handleProfileClick}
            >
              {user?.foto ? (
                <img
                  src={user.foto}
                  alt="Foto de perfil"
                  onError={(e) => (e.target.style.display = "none")}
                  className="rounded-full w-12 h-12 object-cover"
                />
              ) : (
                user?.first_name?.charAt(0).toUpperCase() || "U"
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HeaderPage;
